<template>
  <div v-loading="isLoader" class="Order-Type">

    <el-card class="box-card" style="overflow: visible;">
      <StoreTypeTab />
    </el-card>

    <el-card class="box-card mt-2">
      <div v-if="Object.keys(getAnalyticsData).length">
        <el-row class="pt-2">
          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8">
            <div style="line-height: 40px">
              <span :class="[breadCrumbs.length > 0 ? 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark' : 'text-grey-dark text-sm capitalize']"
                @click="defaultBreadcurmbClicked()">
                {{ $route.name == "SalesOrderType" ? "Order Type" : $route.name }}
                <i class="el-icon-arrow-right" style="font-size: 15px; vertical-align: text-bottom"></i>
              </span>
              <span v-for="(bread_curmb, index) in breadCrumbs" :key="index">
                <span v-for="(key, value, obj_index) in bread_curmb" :key="obj_index">
                  <span :class="[value == active_breadCrumbs ? 'text-grey-dark text-sm capitalize' : 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark']"
                    @click="breadCurmbClicked(value, key)">
                    {{ value }}
                  </span>
                  <span v-if="index != breadCrumbs.length - 1">
                    <i class="el-icon-arrow-right" style="font-size: 15px; vertical-align: text-bottom"></i>
                    &nbsp;
                  </span>
                </span>
              </span>
            </div>
          </el-col>

          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="table-heading">
              <!-- <slot name="headingOfTable"></slot> -->
              <div v-if="selectSalesView">{{ selectSalesView }}</div>
								<div v-else>
									{{ $route.name == 'SalesOrderType' ? "Sale" : "Store Type Sales" }}
								</div>
							</div>
          </el-col>

          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="table-sns">
              <el-select
                v-model="salesView"
                style="width: 270px"
                @change="onSalesViewChange(salesView)"
              >
                <template v-for="(view, index) in allSalesView">
                  <el-option
                    :key="index"
                    :value="view.id"
                    :label="view.name"
                    >{{ view.name }}</el-option
                  >
                </template>
              </el-select>
              <!-- <span class="cursor-pointer" @click="downloadCsvReport(quickReports)">
                <img width="24" height="24" src="https://img.icons8.com/ios/24/000000/export-csv.png" />
              </span> -->
            </div>
          </el-col>
        </el-row>

        <div class="mt-4">
          <div style="position: relative; background: #fff; overflow: hidden;">
            <div class="order-table-wrapper">
              <table v-if="getAnalyticsData.data" class="order-table">
                <thead>
                  <tr>
                    <th
                      v-for="(mainHeading, index) in getAnalyticsData.data.mainHeadings"
                      :key="index"
                      :colspan="mainHeading.colspan"
                      :class="[ index == 0 ? 'headcol' : '' ]"
                      style="border: none; height: 100%;"
                    >
                      <div v-if="mainHeading.value">{{ mainHeading.value }}</div>
                      <div v-else>&nbsp;</div>
                    </th>
                  </tr>
                      <!-- :style="{
                        'min-width':
                          quickReports == 'day' || 'week' || 'month'
                            ? '120px'
                            : '',
                        'text-align': index == 0 ? 'left' : '',
                      }" -->
                  <tr>
                    <th v-for="(subHeading, index) in getAnalyticsData.data.subHeadings" :key="index" :class="[ index == 0 ? 'headcol' : '',  {'mainHeadings-border-bottom': subHeading.isBorder}]"
                    >
                      {{ subHeading.value }}
                    </th>
                  </tr>
                </thead>

                <!-- <div style="width: 100%; max-height: 200px; overflow-y: auto;"> -->
                  <tbody>
                    <tr v-for="(data, index) in getAnalyticsData.data.tableRows" :key="index" :style="{'font-weight': index == 0 ? 'bold' : ''}">
                      <td style="color: #2c9bce; text-transform: capitalize; text-align: left;" class="headcol">
                        <span v-if="disabled || data.label == 'Consolidated'" :class="[data.label == 'Consolidated' ? 'bold-link' : '']">
                          {{ data.label ? data.label : "-" }}
                        </span>

                        <span v-else-if="data.basics == 'outlet'">
                          {{ data.label }}
                        </span>

                        <span v-else :class="[disabled ? 'bold-link' : 'font-bold']">
                          <span v-if="$route.name == 'SalesOrderType'">
                            {{ data.label ? data.label : "-" }}
                          </span>

                          <span v-else @click="rowButtonClicked(data, index)">
                            {{ data.label ? data.label : "-" }}
                          </span>
                        </span>
                      </td>

                      <td v-for="(item, index1) in data.data" :key="index1">
                        <div v-if="item">
                          {{item}}
                        </div>

                        <div v-else style="min-width: 71px;">
                          -
                        </div>
                      </td>
                    </tr>
                  </tbody>
                <!-- </div> -->
              </table>
            </div>
          </div>
        </div>

        <div class="text-right">
          <div class="pagination">
            <el-pagination
              background
              :current-page.sync="pageInfo.currentPage"
              :page-sizes="[5, 10, 15]"
              :page-size.sync="pageInfo.pageSize"
              layout="sizes, prev, pager, next"
              :total="tablePageCount"
              @size-change="handlePageInfoChange"
              @current-change="handlePageInfoChange"
            />
          </div>
        </div>
        <!-- <ReportTable :table-data="getAnalyticsData">
					<template slot="button" slot-scope="{ element, indexOfRow }">
						<span
							v-if="disabled || element.label == 'Consolidated'"
							:class="[
								element.label == 'Consolidated' ? 'bold-link' : ''
							]"
						>
							{{ element.label ? element.label : "-" }}
						</span>
						<span
							v-else-if="element.basics == 'outlet'"
						>
							{{ element.label }}
						</span>

						<span v-else :class="[disabled ? 'bold-link' : 'cursor-pointer font-bold']">
							<span v-if="$route.name == 'SalesOrderType'">
								{{ element.label ? element.label : "-" }}
							</span>

							<span v-else @click="rowButtonClicked(element, indexOfRow)">
								{{ element.label ? element.label : "-" }}
							</span>
						</span>


					</template>
				</ReportTable> -->
      </div>

      <NoDataFound v-if="!Object.keys(getAnalyticsData).length" />
    </el-card>

    <el-card v-if="Object.keys(getAnalyticsData).length" class="box-card mt-2">
      <baseReportGraph />
    </el-card>
  </div>
</template>
<script>
import baseReportGraph from "../../../components/baseReportGraph/baseReportGraph";
import ReportTable from "../appSalesStoreTypeTable/appSalesStoreTypeTable.vue";
import NoDataFound from "../../noDataFound/NoDataFound";
import StoreTypeTab from "../appStoreTypeTab/appStoreTypeTab.vue";
import { mapGetters, mapState } from "vuex";
// import { AppSalesTabNC } from "../../../../../mixins/appSalesTabNC";
import { EventBus } from "../../../eventBus";
import Papa from "papaparse";

// import AppSalesPerformance from "../reportPerformanceCard/ReportPerformanceCard";
export default {
  name: "AppSalesOrderType",
  components: {
    StoreTypeTab,
    baseReportGraph,
    ReportTable,
    NoDataFound,
    // AppSalesPerformance
  },
  // mixins: [AppSalesTabNC],
  data() {
    return {
      disabled: false,
      currentSelectedRow: null,
      loader: false,
      noOfEntries: 10,
      currentPage: 1,
      pageSize: 10,
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      breadCrumbs: [],
      active_breadCrumbs: "",
      selectSalesView: this.$route.name == "SalesOrderType" ? "Transaction" : "Sale",
      salesView: this.$route.name == "SalesOrderType" ? "trans" : "amt",
      allSalesView: [
        {
          name: "Sale",
          id: "amt",
          isVisible: true,
        },
        // {
        //   name: "Average Daily Transaction",
        //   id: "adt",
        //   isVisible: true
        // },
        {
          name: "Transaction",
          id: "trans",
          isVisible: true,
        },
        // {
        //   name: "Average Ticket Size",
        //   id: "at",
        //   isVisible: true
        // },
        {
          name: "Item Per Transaction",
          id: "ipt",
          isVisible: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getAnalyticsData"]),
    ...mapState("CommonStore", ["tablePageCount"]),
    quickReports() {
      return this.$store.getters.getQuickReports;
    },
    selectedView() {
      return this.$store.getters.getselectSalesView;
	},
	isLoader() {
		return this.$store.getters.getLoader;
	}
  },
  mounted() {
    EventBus.$on("disableFirstButton", (payload) => {
      this.disabled = payload;
    });
    EventBus.$on("resetPageInfoEvent", this.handleResetPageInfoEvent);

    EventBus.$on("disableFirstButton", (payload) => {});

    EventBus.$on("breadCrumbs", (data) => {
      this.breadCrumbs = data;
    });

    EventBus.$on("activeBreadCrumb", (data) => {
      this.active_breadCrumbs = data;
    });
  },

  beforeDestroy() {
    EventBus.$off("disableFirstButton");
    EventBus.$off("showLoader");
    EventBus.$off("resetPageInfoEvent", this.handleResetPageInfoEvent);
  },

  methods: {
    rowButtonClicked(element, indexOfRow) {
      this.currentSelectedRow = indexOfRow;
      this.disabled = true;
      console.log("element in sales location", element, indexOfRow);
      if (element.isShowGraph) {
        this.showGraphForPartRow(indexOfRow);
      }
      EventBus.$emit("buttonClickedEvent", element);
    },

    showGraphForPartRow(index) {
      const row = this.getAnalyticsData.data.rows[index];
      this.$store.commit("setNameOfGraph", row[0].value);
      const headings = this.getAnalyticsData.data.headings;
      this.plotOnlyDateGroupGraph(headings, row);
    },

    onSalesViewChange(salesView) {
      if (salesView == "amt") {
				this.selectSalesView = "Sale";
			} else if (salesView == "trans") {
				this.selectSalesView = "Transaction";
			} else if (salesView == "ipt") {
				this.selectSalesView = "Item Per Transaction";
			}
			this.$store.commit("setNameOfGraph", this.selectSalesView);
      EventBus.$emit("salesViewChanged", salesView);
    },

    createCsvJson(tableData) {
      var headings = tableData.data.headings;
      var subHeadings = tableData.data.subHeadings;
      var mainHeadings = tableData.data.mainHeadings;
      var csvSubHeadings = tableData.data.csvSubHeadings;
      if (tableData.data.headings.length) {
        var result = tableData.data.rows.map((row) => {
          var mappedArray = row.map((element, count) => {
            return {
              [headings[count] && headings[count].value]: element.value,
            };
          });
          var obj = {};
          mappedArray.map((el, i) => {
            obj[[headings[i].value]] = el[headings[i].value];
          });
          return obj;
        });
        return result;
      } else {
        let name = tableData.data.subHeadings[0].value;
        var result = tableData.data.tableRows.map((ele) => {
          let obj = {};
          obj[name] = ele.label;
          ele.data.map((el, index) => {
            if (this.quickReports != "sale") {
              obj[subHeadings[index + 1].value] = el;
            } else {
              let key = "";
              key = csvSubHeadings[index + 1].value;
              obj[key] = el;
            }
            return obj;
          });
          return obj;
        });
        console.log("result", result);
        return result;
      }
    },

    downloadCsvReport(tableData) {
      console.log("tableData", this.tableData);
      var export_csv = this.createCsvJson(this.tableData);
      // *****************download csv file************************************
      var csv = Papa.unparse(export_csv);
      var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "download.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      // tempLink.setAttribute("download", "download.csv");
      if (this.quickReports == "sale") {
        tempLink.setAttribute(
          "download",
          `Workforce Report ${localStorage.getItem("dateRange")}.csv`
        );
        tempLink.click();
      } else {
        tempLink.setAttribute(
          "download",
          `${this.quickReports} Repot ${localStorage.getItem("dateRange")} .csv`
        );
        tempLink.click();
      }
    },

    handleResetPageInfoEvent() {
      // console.log("resetting pageInfo");
      this.pageInfo.currentPage = 1;
      this.pageInfo.pageSize = 10;
    },

    handlePageInfoChange(val) {
      const routeName = this.$route.name;
      // console.log("routename", this.$route.name);
      // console.log(`${val} items per page`);
      if (
        // if current page is greater than total pages then make the current page to the the last page.
        this.pageInfo.currentPage >
        this.tablePageCount / this.pageInfo.pageSize
      ) {
        this.pageInfo.currentPage = Math.ceil(
          this.tablePageCount / this.pageInfo.pageSize
        );
      }
      // if (this.pageInfo.currentPage == 0) {
      // 	this.pageInfo.currentPage = 1;
      // }
      if (routeName == "forecastLocation" || routeName == "forecastCategory") {
        EventBus.$emit("pageInfoChangeForecastEvent", this.pageInfo);
      }
      if (routeName == "Location" || routeName == "Category") {
        EventBus.$emit("pageInfoChangeSalesEvent", this.pageInfo);
      }
    },
    // handleCurrentChange(val) {
    // 	const routeName = this.$route.name;
    // 	if (routeName == "forecastLocation" || routeName == "forecastCategory") {
    // 		EventBus.$emit("currentPageChangeForecastEvent", this.currentPage);
    // 	}
    // 	if (routeName == "Location" || routeName == "Category") {
    // 		EventBus.$emit("currentPageChangeSalesEvent", this.currentPage);
    // 	}
    // },

    breadCurmbClicked(selected_bredcrumb, element) {
      EventBus.$emit("activeBreadCrumb", selected_bredcrumb);
      const routeName = this.$route.name;
      EventBus.$emit("clickBreadcurmbReportEvent", selected_bredcrumb, element);
    },

    defaultBreadcurmbClicked() {
      EventBus.$emit("clickToShowInitialReportData");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./appSalesOrderType.scss";
.AppWoowGraph {
  margin: 0;
}
</style>
<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f7ba89;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #000;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  border-radius: 50% !important;
}
.el-pager li {
  border-radius: 50% !important;
}
.mainHeadings-border-bottom {
  border-bottom: 2px solid #999;
  padding: 0 0 10px;
}
.order-table-wrapper {
	min-width: 1000px;
	overflow-x: auto;
	margin-left: 12%;
}
.headcol {
	position: absolute;
	width: 12%;
	left: 0;
	background: #fff;
	border-bottom: 1px solid #dddddd;
	// border-right: 1px solid #dddddd;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 2px 0 6px -5px #d3d3d3;
	// box-shadow: 0px 1px 3px -1px #000;
	height: 40px;
}
.order-table {
	min-width: 100%;
	// min-height: 300px;
	text-align: center;
	tr {
		border-bottom: 1px solid #dddddd;
	}
	td {
		padding: 10px;
		font-size: 14px;
		height: 40px;
		color: #606266;
		font-size: 13px;
		// min-width: 120px
	}
	th{
		padding: 10px;
		font-size: 14px;
		color: #707070;
		font-size: 11px;
		text-transform: uppercase;
		background-color: #f2f2f2;
	}
}
</style>
